export default __webpack_public_path__ + "static/media/department1.96accec5.png";